export enum WidgetSettingTab {
	END_POINT_TAB = 'endpoint',
	VISUAL_TAB = 'visual',
	SETTINGS_TAB = 'settings',
	FILTERS_TAB = 'filters'
}